@if (loading) {
  <div class="loader">
    <p-progressSpinner/>
      <h1>Loading...</h1>
      <i class="small">{{loadingState}}</i>
  </div>
}
<app-render-grid [style.display]="loading ? 'none' : 'flex'" [class.spawn]="!loading" />

